import {
  ALL,
  FAVOURITES,
  FAVOURITES_ANALYTICS_VIEW,
  SELECT,
} from "../../../../constants/analytics";
import { sendAnalyticsEvent } from "../../../../lib/postMessage";
import { generateDescription } from "../../../../lib/string";
import styles from "./FavouriteSelection.module.scss";

export function FavouriteSelection({
  markets,
  name,
  id,
  selectedFavourite,
  setSelectedFavourite,
}) {
  return (
    <li
      className={`${styles.filterSelection} ${
        selectedFavourite === id ? styles["filterSelection--active"] : ""
      }`}
      onClick={() => {
        setSelectedFavourite(selectedFavourite === id ? null : id);
        sendAnalyticsEvent({
          event: FAVOURITES,
          type: FAVOURITES_ANALYTICS_VIEW,
          action: SELECT,
          value: name,
        });
      }}
      data-testid={`selection-${name.toLowerCase().split(" ").join("-")}`}
    >
      <div className={`${styles.filterName}`}>
        <h4>{name}</h4>
        <p className={styles.filterDescription}>
          {generateDescription(markets)}
        </p>
      </div>
      <div className={styles.selectionCheckbox}>
        <div className={styles.selectionCheckbox__checkbox}></div>
      </div>
    </li>
  );
}
